import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RestService } from '../services/rest.service';


@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(
    private restHttp: RestService
  ) { }

  getAllOrders(): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/AllOrders`);
  }



}
